"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.longStatusMessages = exports.shortStatusMessages = void 0;
const patientCondition_1 = require("../../forms/ltx/patientCondition");
exports.shortStatusMessages = {
    [patientCondition_1.Status.NEW]: {
        id: "patient_status.short.new",
        defaultMessage: "ÚJ"
    },
    [patientCondition_1.Status.READY_FOR_COMMITTEE]: {
        id: "patient_status.short.ready_for_committee",
        defaultMessage: "BR"
    },
    [patientCondition_1.Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
        id: "patient_status.short.waiting_for_medical_examination",
        defaultMessage: "KVV"
    },
    [patientCondition_1.Status.TRANSPLANTABLE]: {
        id: "patient_status.short.transplantable",
        defaultMessage: "T"
    },
    [patientCondition_1.Status.NON_TRANSPLANTABLE]: {
        id: "patient_status.short.non_transplantable",
        defaultMessage: "NT"
    },
    [patientCondition_1.Status.NATIONAL_HIGH_URGENT]: {
        id: "patient_status.short.national_high_urgent",
        defaultMessage: "NHU"
    },
    [patientCondition_1.Status.HIGH_URGENT]: {
        id: "patient_status.short.high_urgent",
        defaultMessage: "HU"
    },
    [patientCondition_1.Status.UNSUITABLE]: {
        id: "patient_status.short.unsuitable",
        defaultMessage: "ALK"
    },
    [patientCondition_1.Status.LTX_DONE]: {
        id: "patient_status.short.ltx_done",
        defaultMessage: "LTX"
    },
    [patientCondition_1.Status.EXIT]: {
        id: "patient_status.short.exit",
        defaultMessage: "EX"
    }
};
exports.longStatusMessages = {
    [patientCondition_1.Status.NEW]: {
        id: "patient_status.long.new",
        defaultMessage: "Új"
    },
    [patientCondition_1.Status.READY_FOR_COMMITTEE]: {
        id: "patient_status.long.ready_for_committee",
        defaultMessage: "Bizottsági Referálásra Kész"
    },
    [patientCondition_1.Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
        id: "patient_status.long.waiting_for_medical_examination",
        defaultMessage: "Kiegészítő Vizsgálatra Vár"
    },
    [patientCondition_1.Status.TRANSPLANTABLE]: {
        id: "patient_status.long.transplantable",
        defaultMessage: "Transzplantálható"
    },
    [patientCondition_1.Status.NON_TRANSPLANTABLE]: {
        id: "patient_status.long.non_transplantable",
        defaultMessage: "Nem Transzplantálható"
    },
    [patientCondition_1.Status.NATIONAL_HIGH_URGENT]: {
        id: "patient_status.long.national_high_urgent",
        defaultMessage: "Nemzeti High Urgent"
    },
    [patientCondition_1.Status.HIGH_URGENT]: {
        id: "patient_status.long.high_urgent",
        defaultMessage: "High Urgent"
    },
    [patientCondition_1.Status.UNSUITABLE]: {
        id: "patient_status.long.unsuitable",
        defaultMessage: "Alkalmatlan"
    },
    [patientCondition_1.Status.LTX_DONE]: {
        id: "patient_status.long.ltx_done",
        defaultMessage: "LTX megtörtént"
    },
    [patientCondition_1.Status.EXIT]: {
        id: "patient_status.long.exit",
        defaultMessage: "Exit"
    }
};
